export const formatUserData = (user, isNew) => {
	const currentTime = new Date();
	let userFields = {};

	//Remove & Reformat fields
	if (user.phoneMobile) {
		user.phoneMobile = user.phoneMobile.match(/[0-9]/g).join('');
	}
	if (user.phoneWork) {
		user.phoneWork = user.phoneWork.match(/[0-9]/g).join('');
	}

	if (isNew) {
		userFields = {
			...user,
			displayName: user.nameFirst + ' ' + user.nameLast,
			dateCreated: currentTime,
			showWelcome: true
		};
	} else {
		userFields = {
			...user,
			displayName: user.nameFirst + ' ' + user.nameLast,
			dateUpdated: currentTime
		};
	}

	// Format Company into an Object to store
	if (user.companyLink) {
		const sep = user.companyLink.indexOf('__');
		const compId = user.companyLink.substring(0, sep);
		const compName = user.companyLink.substring(sep + 2);

		userFields.companyObj = {
			name: compName,
			id: compId
		};
	}

	return {
		...userFields
	};
};
